import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import superChatActions from 'ai/actions/superChatActions';
import ShoppingListIdsSelector from 'selectors/loves/shoppingListIds/shoppingListIdsSelector';
import EN from 'ai/components/SuperChat/locales/SuperChat_en_US.js';
import FR from 'ai/components/SuperChat/locales/SuperChat_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const { shoppingListIdsSelector } = ShoppingListIdsSelector;
const getText = getLocalisedDataFromResource(EN, FR);

const localization = createStructuredSelector({
    new: getTextFromResource(getText, 'new'),
    size: getTextFromResource(getText, 'size'),
    addToBasket: getTextFromResource(getText, 'addToBasket'),
    purchasedOn: getTextFromResource(getText, 'purchasedOn'),
    color: getTextFromResource(getText, 'color'),
    shade: getTextFromResource(getText, 'shade'),
    variant: getTextFromResource(getText, 'variant'),
    viewAll: getTextFromResource(getText, 'viewAll')
});

const functions = {
    addToBasket: superChatActions.addToBasket,
    addToLovesList: superChatActions.addToLovesList,
    closeSuperChat: superChatActions.closeSuperChat
};

const fields = createSelector(localization, shoppingListIdsSelector, (locales, shoppingListIds) => {
    return {
        localization: locales,
        shoppingListIds
    };
});

const withProductRecommendationProps = wrapHOC(connect(fields, functions));

export {
    withProductRecommendationProps, fields, functions
};
